"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
exports.FeedbackSchema = base_1.BaseSchema.extend({
    storeId: base_1.ShortStringSchema.uuid(),
    rating: zod_1.z.number().min(0).max(10),
    comment: base_1.MediumStringSchema.optional(),
    sourceDevice: base_1.ShortStringSchema.optional(),
});
//# sourceMappingURL=index.js.map